export default __webpack_public_path__ + "static/media/flag.12ca02a6.svg";